export function initCookieConsent() {
    window.cookieconsent.initialise({
        palette: {
            popup: {
                background: '#353535',
            },
            button: {
                background: '#f1d600',
            },
        },
        theme: 'classic',
        content: {
            message:
                'This website uses cookies in order to offer you the most relevant information. Please accept cookies for optimal performance.',
            dismiss: 'Yes, I accept Cookies',
        },
    });
}
